var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable max-len */
import React, { useState } from 'react';
import { Grid, makeStyles, } from '@material-ui/core';
import './LegalConsent.css';
import { useTranslation } from 'react-i18next';
import { TERMS_OF_USE, TERMS_OF_SERVICE, PRIVACY_POLICY } from '../../constants/constants';
import { useLegalDocuments } from '../../hooks/useLegalDocuments';
import { LEGAL_DOCUMENTS } from '../../constants/legalDocuments';
import { useEnqueueSnackbar } from '../../hooks/useEnqueueSnackbar';
var useStyles = makeStyles(function (theme) { return ({
    link: {
        marginBottom: '5px',
        cursor: 'pointer',
        color: theme.palette.primary.main,
    },
}); });
var UpdatedDocuments = function (_a) {
    var updatedDocuments = _a.updatedDocuments, setLoading = _a.setLoading;
    var t = useTranslation().t;
    var classes = useStyles();
    var snackbar = useEnqueueSnackbar();
    var fetchLegalPdf = useLegalDocuments().fetchLegalPdf;
    var _b = __read(useState({}), 2), pdfFiles = _b[0], setPdfFiles = _b[1];
    var downloadPdf = function (pdfUrl, title) {
        var a = document.createElement('a');
        a.href = pdfUrl;
        a.download = "".concat(title, ".pdf");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    var downloadLegalDocument = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var legalDoc, pdfUrl, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    legalDoc = LEGAL_DOCUMENTS[key];
                    if (!pdfFiles[key]) return [3 /*break*/, 1];
                    downloadPdf(pdfFiles[key], t(legalDoc.pdf_title));
                    return [3 /*break*/, 4];
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    setLoading(true);
                    return [4 /*yield*/, fetchLegalPdf(key)];
                case 2:
                    pdfUrl = _b.sent();
                    setPdfFiles(__assign(__assign({}, pdfFiles), (_a = {}, _a[key] = pdfUrl, _a)));
                    setLoading(false);
                    downloadPdf(pdfUrl, t(legalDoc.pdf_title));
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    snackbar.enqueueMessages(t('Error retrieving legal document, please try again or contact administrator'), 'error');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Grid, { className: "text-simple1" }, updatedDocuments.length > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("p", null, t('We have made some changes to some of our legal documents. By clicking accept, you acknowledge and agree that you have read and agree to the updated terms.')),
        React.createElement("div", { style: { marginBottom: '25px' } },
            updatedDocuments.includes(TERMS_OF_USE)
                && (React.createElement("div", { className: classes.link, onClick: function () { return downloadLegalDocument('termsOfUse'); } }, t('Michelin Terms of Use'))),
            updatedDocuments.includes(TERMS_OF_SERVICE)
                && (React.createElement("div", { className: classes.link, onClick: function () { return downloadLegalDocument('termsOfService'); } }, t('Michelin Terms of Service'))),
            updatedDocuments.includes(PRIVACY_POLICY)
                && (React.createElement("div", { className: classes.link, onClick: function () { return downloadLegalDocument('privacyPolicy'); } }, t('Michelin Privacy Notice')))))) : (React.createElement(React.Fragment, null,
        React.createElement("p", null,
            t('By clicking accept, you acknowledge and agree that you have read and agree to the'),
            "\u00A0",
            React.createElement("span", { className: classes.link, onClick: function () { return downloadLegalDocument('termsOfUse'); } }, t('Michelin Terms of Use')),
            "\u00A0",
            t('and the'),
            "\u00A0",
            React.createElement("span", { className: classes.link, onClick: function () { return downloadLegalDocument('termsOfService'); } }, t('Michelin Terms of Service')),
            ",",
            ' ',
            t('and to the collection, use and sharing of your information by Michelin as set forth in the'),
            "\u00A0",
            React.createElement("span", { className: classes.link, onClick: function () { return downloadLegalDocument('privacyPolicy'); } }, t('Michelin Privacy Notice')),
            ".")))));
};
export default UpdatedDocuments;
//# sourceMappingURL=LegalConsentContent.js.map